import React from "react"
import styles from "./RegisterGoogleSimple.module.css"
import { RegisterGoogleSimpleProps } from "./types"
import { useGtm } from '../../../../../../../hooks/useGtm'

export default function RegisterGoogleSimple({
    reasonPoint1Images,
    signupPath,
}: RegisterGoogleSimpleProps) {
    const signupUrl = `/${signupPath || "signup?channel=googleadwords"}`

    useGtm(['GTM-MJ9GMNND', 'GTM-PZVGNPT'])

    return (
        <>
            <div className={styles.container}>
                <div className={styles.firstView}>
                    <header>
                        <img
                            src="/pages/google/Common/Foodslabo/Simple/logo.png"
                            alt="FoodsLabo"
                        />
                    </header>
                    <div className={styles.firstViewBox}>
                        <img
                            className={styles.firstViewImg1}
                            src="/pages/google/Common/Foodslabo/Simple/fv_title.png"
                            alt="飲食業界で働く方に支持される転職サービスNo.1 -エージェントサポート-"
                        />
                        <img
                            className={styles.firstViewImg2}
                            src="/pages/google/Common/Foodslabo/Simple/fv_scout.png"
                            alt="登録するだけで飲食企業からスカウトが届く！"
                        />
                        <img
                            className={styles.firstViewImg3}
                            src="/pages/google/Common/Foodslabo/Simple/fv_image_sp.png"
                            alt="飲食業界で働く方に支持される転職サービスNo.1 -エージェントサポート-"
                        />
                    </div>
                </div>
                <img
                    className={styles.firstViewBannerSp}
                    src="/pages/google/Common/Foodslabo/Simple/fv_scout.png"
                    alt="登録するだけで飲食企業からスカウトが届く！"
                />

                <div className={styles.entryCta}>
                    <a
                        className={styles.entryCtaA}
                        href={signupUrl}
                    >
                        無料登録して求人を見る
                    </a>
                </div>

                <img
                    className={styles.firstView3}
                    src="/pages/google/Common/Foodslabo/Simple/no1_img_1.png"
                    alt="FoodsLabo 3冠達成"
                />

                <div className={styles.firstViewNo1Box}>
                    <img
                        className={styles.firstViewNo1_1}
                        src="/pages/google/Common/Foodslabo/Simple/no1_img_2.png"
                        alt="飲食業界への転職におすすめの転職サービスNo.1"
                    />
                    <img
                        className={styles.firstViewNo1_2}
                        src="/pages/google/Common/Foodslabo/Simple/no1_img_3.png"
                        alt="飲食業界で働く20代、30代に支持される転職サービスNo.1"
                    />
                    <img
                        className={styles.firstViewNo1_3}
                        src="/pages/google/Common/Foodslabo/Simple/no1_img_4.png"
                        alt="飲食業界で働く方に支持される転職サービスNo.1"
                    />
                    <p>
                        2023 年 3 月期_ブランドのイメージ調査(調査 1~3)
                        ・調査機関:日本マーケティングリサーチ機構・調査期間:2023年1月5日~2023年3月14日・n
                        数:127(※調査 1)、147(※調査 2)、591(※調査 3)/調査方法:Web
                        アンケート・調査対象者:https://jmro.co.jp/r01414/・備考:本調査は個人のブランドに対するイメージを元にアンケートを実施し集計しております。/
                        本ブランドの利用有無は聴取しておりません。/効果効能等や優位性を保証するものではございません。/競合
                        2 位との差は 5%以上。
                    </p>
                </div>

                <section id="reason" className={styles.reason}>
                    <h1>
                        <img
                            src="/pages/google/Common/Foodslabo/Simple/reason_h1.png"
                            alt="FoodLaboが選ばれる4つの理由"
                        />
                    </h1>

                    <div className={styles.reasonPoint1}>
                        <h2>
                            <img
                                src="/pages/google/Common/Foodslabo/Simple/reason_point1_h1.png"
                                alt="POINT1 FoodsLaboだけの限定求人"
                            />
                        </h2>
                        <img
                            className={styles.reasonPoint1Arrow}
                            src="/pages/google/Common/Foodslabo/Simple/reason_arrow.png"
                            alt=""
                        />
                        <div className={styles.reasonPoint1Box}>
                            {reasonPoint1Images.map((image, index) => (
                                <img
                                    key={index}
                                    src={image.src}
                                    alt={image.alt}
                                />
                            ))}
                        </div>
                        <div className={styles.entryCta}>
                            <a
                                className={styles.entryCtaA}
                                href={signupUrl}
                            >
                                無料登録して求人を見る
                            </a>
                        </div>
                        <img
                            className={styles.reasonPoint1Voice}
                            src="/pages/google/Common/Foodslabo/Simple/reason_point1_voice.png"
                            alt=""
                        />
                    </div>

                    <div className={styles.reasonPoint2}>
                        <div className={styles.reasonPoint2Box}>
                            <h2 className={styles.reasonPoint2H2Pc}>
                                <img
                                    src="/pages/google/Common/Foodslabo/Simple/reason_point2_h1_pc.png"
                                    alt="POINT2 登録するだけでスカウトが届く"
                                />
                            </h2>
                            <h2 className={styles.reasonPoint2H2Sp}>
                                <img
                                    src="/pages/google/Common/Foodslabo/Simple/reason_point2_h1_sp.png"
                                    alt="POINT2 登録するだけでスカウトが届く"
                                />
                            </h2>
                            <img
                                className={styles.reasonPoint1Arrow}
                                src="/pages/google/Common/Foodslabo/Simple/reason_arrow.png"
                                alt=""
                            />
                            <img
                                className={styles.reasonPoint2Img}
                                src="/pages/google/Common/Foodslabo/Simple/reason_point2_scout.png"
                                alt="たとえばこんなスカウトが..."
                            />
                            <img
                                className={styles.reasonPoint2Voice}
                                src="/pages/google/Common/Foodslabo/Simple/reason_point2_voice.png"
                                alt="企業からのアプローチを待ちましょう！"
                            />
                        </div>
                    </div>

                    <div className={styles.reasonPoint3}>
                        <div className={styles.reasonPoint3Box}>
                            <h2 className={styles.reasonPoint3H2Pc}>
                                <img
                                    src="/pages/google/Common/Foodslabo/Simple/reason_point3_h1_pc.png"
                                    alt="POINT3 かんたんweb職歴だけで応募できる！"
                                />
                            </h2>
                            <h2 className={styles.reasonPoint3H2Sp}>
                                <img
                                    src="/pages/google/Common/Foodslabo/Simple/reason_point3_h1_sp.png"
                                    alt="POINT3 かんたんweb職歴だけで応募できる！"
                                />
                            </h2>
                            <img
                                className={styles.reasonPoint1Arrow}
                                src="/pages/google/Common/Foodslabo/Simple/reason_arrow.png"
                                alt=""
                            />
                            <img
                                className={styles.reasonPoint3ImgPc}
                                src="/pages/google/Common/Foodslabo/Simple/reason_point3_scout_pc.png"
                                alt="あなたの直近の経歴は？"
                            />
                            <img
                                className={styles.reasonPoint3ImgSp}
                                src="/pages/google/Common/Foodslabo/Simple/reason_point3_scout_sp.png"
                                alt="あなたの直近の経歴は？"
                            />
                            <img
                                className={styles.reasonPoint3Voice}
                                src="/pages/google/Common/Foodslabo/Simple/reason_point3_voice.png"
                                alt="登録時に入力したweb職務経歴書のみで応募できます！"
                            />
                        </div>
                    </div>

                    <div className={styles.reasonPoint4}>
                        <div className={styles.reasonPoint4Box}>
                            <h2 className={styles.reasonPoint4H2Pc}>
                                <img
                                    src="/pages/google/Common/Foodslabo/Simple/reason_point4_h1_pc.png"
                                    alt="POINT4 転職成功者の声"
                                />
                            </h2>
                            <h2 className={styles.reasonPoint4H2Sp}>
                                <img
                                    src="/pages/google/Common/Foodslabo/Simple/reason_point4_h1_sp.png"
                                    alt="POINT4 転職成功者の声"
                                />
                            </h2>
                            <img
                                className={styles.reasonPoint4Img}
                                src="/pages/google/Common/Foodslabo/Simple/reason_point4_scout.png"
                                alt="転職成功者の声"
                            />
                        </div>
                        <img
                            className={styles.reasonPoint4Voice}
                            src="/pages/google/Common/Foodslabo/Simple/reason_point4_voice.png"
                            alt="転職成功者の声"
                        />
                        <div className={styles.entryCtaB}>
                            <a
                                className={styles.entryCtaA}
                                href={signupUrl}
                            >
                                無料登録して求人を見る
                            </a>
                        </div>
                    </div>
                </section>

                <section
                    id="after_registration"
                    className={styles.afterRegistration}
                >
                    <h2>
                        <img
                            src="/pages/google/Common/Foodslabo/Simple/after_h2.png"
                            alt="登録後はどうするの？"
                        />
                    </h2>
                    <div className={styles.afterBox}>
                        <img
                            src="/pages/google/Common/Foodslabo/Simple/after_img_1.png"
                            alt="1.スカウトを受け取る"
                        />
                        <img
                            src="/pages/google/Common/Foodslabo/Simple/after_img_2.png"
                            alt="求人を見つける"
                        />
                        <img
                            src="/pages/google/Common/Foodslabo/Simple/after_img_3.png"
                            alt="2.気になる求人・スカウトされた求人に応募する"
                        />
                        <img
                            src="/pages/google/Common/Foodslabo/Simple/after_img_4.png"
                            alt="3.面接に向かう"
                        />
                        <img
                            src="/pages/google/Common/Foodslabo/Simple/after_img_5.png"
                            alt="4.入社決定！"
                        />
                    </div>
                    <img
                        className={styles.afterImgSp}
                        src="/pages/google/Common/Foodslabo/Simple/after_img.png"
                        alt="登録後の流れ"
                    />
                    <div className={`${styles.entryCta} ${styles.ctaAfter}`}>
                        <a
                            className={styles.entryCtaA}
                            href={signupUrl}
                        >
                            無料登録して求人を見る
                        </a>
                    </div>
                    <img
                        className={styles.afterVoice}
                        src="/pages/google/Common/Foodslabo/Simple/after_voice.png"
                        alt="あなたもフーズラボで「人生を面白く」できる転職、してみませんか？"
                    />
                </section>

                <footer className={styles.footer}>
                    <small>
                        Copyright &copy; {new Date().getFullYear()} foodsLabo by
                        cuolega All rights reserved.
                    </small>
                    <div>
                        <a href="https://cuolega.co.jp/privacy/">
                            プライバシーポリシー
                        </a>
                        <a href="https://cuolega.co.jp/terms/">利用規約</a>
                        <a href="https://cuolega.co.jp/profile/">会社概要</a>
                    </div>
                </footer>
            </div>
        </>
    )
}
